import { format } from 'date-fns';

interface Props {
  /** Called when the user picks or clears a date */
  onChange: (date: Date | undefined) => void;
  /** Currently selected date (controlled) */
  value?: Date;
}

const DatePicker = ({ onChange, value }: Props) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.value) {
      // Native clear (×) button was clicked — reset to undefined
      onChange(undefined);
      return;
    }
    onChange(new Date(e.target.value));
  };

  return (
    <div className="relative flex items-center">
      <input
        type="date"
        max={format(new Date(), 'yyyy-MM-dd')}
        value={value ? format(value, 'yyyy-MM-dd') : ''}
        onChange={handleChange}
        className="border p-1 rounded-md text-[13px] font-medium cursor-pointer w-full h-full"
      />
    </div>
  );
};

export default DatePicker;
